// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-thumbnail[data-v-2100616d]{border:1px solid #d1d2db;border-radius:10.4px}.img-content[data-v-2100616d]{min-width:160px;max-width:160px;height:100px;background-size:cover;background-position:top}", ""]);
// Exports
module.exports = exports;
